import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function HomeIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="HomeIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="FontAwsome_home_"
                d="M12.432,37.209,4.247,43.95v7.276a.71.71,0,0,0,.71.71l4.975-.013a.71.71,0,0,0,.707-.71V46.964a.71.71,0,0,1,.71-.71h2.841a.71.71,0,0,1,.71.71V51.21a.71.71,0,0,0,.71.713l4.973.014a.71.71,0,0,0,.71-.71V43.946l-8.183-6.736a.541.541,0,0,0-.679,0Zm12.929,4.582L21.65,38.732V32.583a.533.533,0,0,0-.533-.533H18.631a.533.533,0,0,0-.533.533v3.223l-3.975-3.27a2.131,2.131,0,0,0-2.708,0L.178,41.791a.533.533,0,0,0-.071.75l1.132,1.376a.533.533,0,0,0,.751.072l10.443-8.6a.541.541,0,0,1,.679,0l10.443,8.6a.533.533,0,0,0,.75-.071l1.132-1.376a.533.533,0,0,0-.075-.752Z"
                transform="translate(0.516 -31.462)"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
            />
        </SvgIcon>
    );
}
